const dialog    = require ('../../../../../components/dialog/dialog')
const textfieldMultiselect = require('../../../../../components/textfield/textfield-multiselect')
const dtHandler = require('../../../../../components/dt/dt-handler')

const { getTransactionEntityName, escapeTransactionText } = require('./transaction-dt-handler')

const statusColumns = [
    { key: 'entity', label: 'Entity', behavior: false, displayText: true },
    { key: 'code', label: 'Code', behavior: false, displayText: true },
    { key: 'account', label: 'Account', behavior: false, displayText: true },
    { key: 'type', label: 'Credit / Debit', behavior: false, displayText: true },
    { key: 'status', label: 'Status', behavior: false, displayText: true },
    { key: 'amount', label: 'Amount', behavior: false, displayText: true, format: 'cash' },
    { key: 'date', label: 'Date', behavior: false, displayText: true },
]

function statusRows(rows) {
    return rows.map((row) => {
        const status = row.status || 'pending'
        return {
            entity: escapeTransactionText(getTransactionEntityName(row.entity)),
            code: escapeTransactionText(row.code),
            account: escapeTransactionText(row.account_name),
            type: ['in', 'debit'].includes(row.action) ? 'Debit' : 'Credit',
            status: escapeTransactionText(status.charAt(0).toUpperCase() + status.slice(1)
                + (row.reconciled ? ' (Account Reconciliation)' : '')),
            amount: Number(row.amount) || 0,
            date: escapeTransactionText(row.date),
        }
    })
}

export function start( detail ){ //console.log('dialog GOKU detail', detail)

	dialogBody[detail.id].start(detail)
	
	detail.html =  dialogBody[detail.id]
	dialog.start(detail)

    if (detail.id === 'transactionStatus') {
        const rows = Array.isArray(detail.rows) ? detail.rows : []
        document.getElementById('transaction-status-rows').innerHTML = dtHandler.dtSimpleFc(statusRows(rows), statusColumns)
        textfieldMultiselect.createChoose({
            html: document.getElementById('transaction-status'),
            options: [
                { value: 'pending', text: 'Pending' },
                { value: 'cleared', text: 'Cleared' },
                { value: 'canceled', text: 'Canceled' },
            ],
            value: 'pending',
            includeEmptyOption: false,
        })
    }
}

const dialogBody = {

    transactionStatus: {
        title: '',
        des: 'Applies to all unreconciled movements of the selected records. Movements cleared by Account Reconciliation keep their status.',
        bodyHtml: `
            <div id="transaction-status-rows"></div>
            <div class="textfield textfield-desk textfield-multiselect textfield-filled" id="transaction-status">
                <select class="elem"></select>
                <div class="indicador"></div>
                <div class="trailing">
                    <svg><use xlink:href="./css/svg.svg#downs"></use></svg>
                </div>
                <div class="label">Status</div>
            </div>
            <label class="des" id="transaction-status-message"></label>
        `,
        primary: { text: 'Apply', class: 'button primary', dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"transaction","elem":"dt","act":"applyStatus"}]}'` },
        secondary: { text: 'Cancel', class: 'button secondary button-plain', dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'` },
        tertiary: { text: '', class: '', dataDetail: '' },
        start: function(detail) {
            this.title = `Status (${detail.count})`
        },
    },

    statusError: {
        title: 'Unable to change status',
        des: '',
        bodyHtml: '',
        primary: { text: 'OK', class: 'button primary', dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'` },
        secondary: { text: '', class: '', dataDetail: '' },
        tertiary: { text: '', class: '', dataDetail: '' },
        start: function(detail) {
            const rows = Array.isArray(detail.rows) ? detail.rows : []
            if (detail.message) {
                this.des = escapeTransactionText(detail.message)
            } else if (rows.length > 0) {
                this.des = 'The movements listed below cannot change status here. Modify them from Account Reconciliation. No changes were applied.'
            } else {
                this.des = 'The selection could not be validated. Please try again.'
            }
            this.bodyHtml = rows.length > 0
                ? dtHandler.dtSimpleFc(statusRows(rows), statusColumns)
                : ''
        },
    },

    deleteTransaction: {
        title: '',
        des: '',
        bodyHtml: '',
        primary: { text: 'Cancel', class: 'button primary', dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'` },
        secondary: { text: 'Delete', class: 'button button-flat', dataDetail: '' },
        tertiary: { text: '', class: '', dataDetail: '' },
        start: function(detail) {
            const isAssetDisposal = detail.transactionType === 'asset_disposal'
            this.title = isAssetDisposal ? 'Delete Asset Disposal?' : 'Delete Transfer Between Accounts?'
            this.des = isAssetDisposal
                ? 'The saved asset disposal and its account movements will be deleted, and the asset account will be reactivated. Unsaved changes will be discarded.'
                : 'The saved transfer and its account movements will be deleted. Unsaved changes will be discarded.'
            if (detail.transactionType === 'bounced_check') {
                this.title = 'Delete Bounced Check?'
                this.des = 'The saved bounced check and its account movements will be deleted. The received payment and its invoices will remain unchanged. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'bank_fees') {
                this.title = 'Delete Bank Fees?'
                this.des = 'The saved bank fees and their account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'card_payment') {
                this.title = 'Delete Credit Card Payment?'
                this.des = 'The saved credit card payment and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'depreciation') {
                this.title = 'Delete Depreciation?'
                this.des = 'The saved depreciation and its account movements will be deleted, freeing its date period for this asset. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'equity_deposit') {
                this.title = 'Delete Equity Deposit?'
                this.des = 'The saved equity deposit and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'equity_withdrawal') {
                this.title = 'Delete Equity Withdrawal?'
                this.des = 'The saved equity withdrawal and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'loan_issued') {
                this.title = 'Delete Loan Issued?'
                this.des = 'The saved issued loan and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'loan_issued_payment') {
                this.title = 'Delete Loan Issued Payment?'
                this.des = 'The saved loan payment and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'loan_payment') {
                this.title = 'Delete Loan Payment?'
                this.des = 'The saved loan payment and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'loan_received') {
                this.title = 'Delete Loan Received?'
                this.des = 'The saved received loan and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'operating_expense') {
                this.title = 'Delete Operating Expense?'
                this.des = 'The saved operating expense and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'other_income') {
                this.title = 'Delete Other Income?'
                this.des = 'The saved other income record and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'other_receivable') {
                this.title = 'Delete Other Receivable?'
                this.des = 'The saved other receivable and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            if (detail.transactionType === 'asset_purchase') {
                this.title = 'Delete Purchase Fixed Asset?'
                this.des = 'The saved asset purchase and its account movements will be deleted. Unsaved changes will be discarded.'
            }
            this.secondary.dataDetail = `data-detail='{"click":[
                {"dest":"ripple"},{"dest":"dialog","act":"hide"},
                {"dest":"transaction","elem":"fullcont","act":"deleteFromDialog","id":"transaction-fullcont","dbid":"${detail.dbid}","transactionType":"${detail.transactionType}"}
            ]}'`
        },
    },

    deleteError: {
        title: 'Unable to delete transaction',
        des: '',
        bodyHtml: '',
        primary: { text: 'OK', class: 'button primary', dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'` },
        secondary: { text: '', class: '', dataDetail: '' },
        tertiary: { text: '', class: '', dataDetail: '' },
        start: function(detail) {
            this.des = detail.message || 'The transaction could not be deleted. Please try again.'
        },
    },

	hellow: { 
		title:  '',
		des: '',
		bodyHtml:`

				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input  class= 'elem' type="text"   value="empy1" 
				         data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' >

				  <div class="indicador"></div>

				  <div class="trailing"  data-detail='{"click": [{"dest":"textfield", "act":"clear"}] }' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div> 
				  <div class="helper" >Required*</div>
				  <div class="counter">10/10</div> 
				  <div class="selector"></div>
				</div><!-- textfield -->  


				<div class="textfield textfield-filled  textfield-autocomplete" id="_______">

				  <input  class= 'elem' type="text"   value="empy1" 
				         data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' >

				  <div class="indicador"></div>

				  <div class="trailing"  data-detail='{"click": [{"dest":"textfield", "act":"clear"}] }' >
				    <svg><use xlink:href="../../../public/css/svg.svg#cancel"></use></svg>
				  </div>

				  <div class="label">text</div> 
				  <div class="helper" >Required*</div>
				  <div class="counter">10/10</div> 
				  <div class="selector"></div>
				</div><!-- textfield -->  

		`,

		primary: {
			text:'',
			class:'button primary',
	        dataDetail:`data-detail='{
	                        "click": [
	                            {"dest":"ripple" },
	                            {"dest":"dialog", "act":"hide"} ]}'`,
		},

		secondary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:`data-detail='{ "click": [ {"dest":"ripple" },  {"dest":"dialog", "act":"hide"} ]}'`,
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:`data-detail='{  "click": [ {"dest":"ripple" },  {"dest":"dialog", "act":"hide"} ]}'`,
		},      

		start: function(){
			this.title     = 'TEST title'
			this.des       = ''
			this.primary.text   = 'TEST 111'
			this.secondary.text = 'TEST 222'						
			this.tertiary.text  = 'TEST 33333'						
		}

	},
	
}
